import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getRebookPolicyRebookFlow } from "../../../../store/rebookPolicy/selectors.js";
import { getOrderId } from "../../../../store/order/selectors.js";
import { grumble } from "../../../../utils/flog.js";
import { trackSwitchToRebookStore } from "../../../../utils/experiments/post-booking/flights_web_pbem_switch_to_rebook_store.js";
import useRouteName from "../../../../hooks/useRouteName.js";
export const useRebookFlow = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const rebookFlowFromQuery = queryParams.get("rebookFlow");
    const rebookFlowFromState = useSelector(getRebookPolicyRebookFlow);
    const orderId = useSelector(getOrderId);
    const routeName = useRouteName();
    const isSwitchToRebookStoreInVariant = trackSwitchToRebookStore.trackWithDefaultStage() === 1;
    React.useEffect(() => {
        if (isSwitchToRebookStoreInVariant && (rebookFlowFromState || null) !== (rebookFlowFromQuery || null)) {
            grumble("[rebook] rebookFlow source mismatch", {
                state: rebookFlowFromState,
                query: rebookFlowFromQuery,
                orderId,
                routeName
            });
        }
    }, [isSwitchToRebookStoreInVariant, orderId, routeName, rebookFlowFromQuery, rebookFlowFromState]);
    return isSwitchToRebookStoreInVariant ? rebookFlowFromState : rebookFlowFromQuery;
};
